import React from 'react';

import PillarOverviewSlider from '../../PillarOverviewSlider';

import './style.scss';

// FIXME: Add CMSable body text
// FIXME: Add CMSable title text
const OpinionsPillarOverview = ({ entities, entity, ...props }) => {
  const url = `${window.location.pathname}/opinies`;

  return (
    <PillarOverviewSlider
      className="OpinionsPillarOverview"
      url={url}
      subTitle="Bekijk alle opinies"
      title={entity.getIn(['field_label', 0, 'value'])}
      body={entity.getIn(['field_text', 0, 'processed'])}
      entities={entities}
      {...props}
    />
  );
};

export default OpinionsPillarOverview;
